import { render, staticRenderFns } from "./BulkAddNoteModal.vue?vue&type=template&id=3d2229db"
import script from "./BulkAddNoteModal.vue?vue&type=script&lang=js"
export * from "./BulkAddNoteModal.vue?vue&type=script&lang=js"
import style0 from "./BulkAddNoteModal.vue?vue&type=style&index=0&id=3d2229db&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports